import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { RequestStatus } from "@app/constants";
import { IRequestFailed } from "@app/types";
import { IBrandState } from "./types";

const initialState: IBrandState = {
  brand: {},
  addBrand: {},
  deleteBrand: {},
};

const slice = createSlice({
  name: "brand",
  initialState,
  reducers: {
    brand(state) {
      state.brand.status = RequestStatus.RUNNING;
    },
    brandSuccess(state, action) {
      state.brand.status = RequestStatus.SUCCESS;
      state.brand.data = action.payload;
    },
    brandFailed(state, action: PayloadAction<IRequestFailed>) {
      state.brand.status = RequestStatus.ERROR;
      state.brand.error = action.payload;
    },
    addBrand(state, action) {
      state.addBrand.status = RequestStatus.RUNNING;
    },
    addBrandSuccess(state, action) {
      state.addBrand.status = RequestStatus.SUCCESS;
      state.addBrand.data = action.payload;
    },
    addBrandFailed(state, action: PayloadAction<IRequestFailed>) {
      state.addBrand.status = RequestStatus.ERROR;
      state.addBrand.error = action.payload;
    },
    //
    deleteBrand(state, action: PayloadAction<{ brandId: number }>) {
      state.deleteBrand.status = RequestStatus.RUNNING;
    },
    deleteBrandSuccess(state, action) {
      state.deleteBrand.status = RequestStatus.SUCCESS;
      state.deleteBrand.data = action.payload;
    },
    deleteBrandFailed(state, action: PayloadAction<IRequestFailed>) {
      state.deleteBrand.status = RequestStatus.ERROR;
      state.deleteBrand.error = action.payload;
    },
  },
});

export default slice.reducer;
export const {
  brand,
  brandSuccess,
  brandFailed,
  addBrand,
  addBrandSuccess,
  addBrandFailed,
  deleteBrand,
  deleteBrandFailed,
  deleteBrandSuccess,
} = slice.actions;
